import React from 'react';
import { DownloadIcon, BriefcaseIcon, GraduationCapIcon } from 'lucide-react';
export const CV = () => {
  const experiences = [{
    title: 'Senior UI/UX Designer',
    company: 'Creative Design Agency',
    period: '2021 - Present',
    description: 'Lead designer for web and mobile applications. Conducted user research, created wireframes, prototypes, and high-fidelity designs. Collaborated with development team for implementation.'
  }, {
    title: 'UI/UX Designer',
    company: 'Tech Solutions Inc.',
    period: '2019 - 2021',
    description: 'Designed user interfaces for various digital products. Created user flows, wireframes and interactive prototypes. Conducted usability testing and implemented design improvements.'
  }, {
    title: 'Graphic Designer',
    company: 'Marketing Innovators',
    period: '2017 - 2019',
    description: 'Created visual assets for marketing campaigns including social media graphics, print materials, and digital advertisements. Maintained brand consistency across all materials.'
  }];
  const education = [{
    degree: 'Bachelor of Fine Arts in Graphic Design',
    institution: 'Design University',
    year: '2013 - 2017',
    description: 'Specialized in digital design and user experience. Graduated with honors.'
  }, {
    degree: 'UI/UX Design Certification',
    institution: 'Design Academy Online',
    year: '2018',
    description: 'Professional certification in user interface and user experience design principles and methodologies.'
  }];
  return <section id="cv" className="py-20 px-6 md:px-12 bg-black bg-opacity-70" data-id="element-66">
      <div className="max-w-6xl mx-auto" data-id="element-67">
        <div className="flex justify-between items-center mb-12" data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-69">
            Curriculum Vitae
          </h2>
          <button className="flex items-center px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-all" data-id="element-70">
            <DownloadIcon size={18} className="mr-2" data-id="element-71" />
            Download CV
          </button>
        </div>
        <div className="grid md:grid-cols-2 gap-12" data-id="element-72">
          <div data-id="element-73">
            <div className="flex items-center mb-6" data-id="element-74">
              <BriefcaseIcon size={24} className="text-purple-400 mr-3" data-id="element-75" />
              <h3 className="text-2xl font-bold text-white" data-id="element-76">Experience</h3>
            </div>
            <div className="space-y-8" data-id="element-77">
              {experiences.map((exp, index) => <div key={index} className="relative pl-8 border-l-2 border-purple-800" data-id="element-78">
                  <div className="absolute -left-2.5 top-0 h-5 w-5 rounded-full bg-purple-600" data-id="element-79"></div>
                  <h4 className="text-xl font-bold text-white" data-id="element-80">{exp.title}</h4>
                  <div className="flex items-center text-purple-400 mb-2" data-id="element-81">
                    <span data-id="element-82">{exp.company}</span>
                    <span className="mx-2" data-id="element-83">•</span>
                    <span data-id="element-84">{exp.period}</span>
                  </div>
                  <p className="text-gray-300" data-id="element-85">{exp.description}</p>
                </div>)}
            </div>
          </div>
          <div data-id="element-86">
            <div className="flex items-center mb-6" data-id="element-87">
              <GraduationCapIcon size={24} className="text-purple-400 mr-3" data-id="element-88" />
              <h3 className="text-2xl font-bold text-white" data-id="element-89">Education</h3>
            </div>
            <div className="space-y-8" data-id="element-90">
              {education.map((edu, index) => <div key={index} className="relative pl-8 border-l-2 border-purple-800" data-id="element-91">
                  <div className="absolute -left-2.5 top-0 h-5 w-5 rounded-full bg-purple-600" data-id="element-92"></div>
                  <h4 className="text-xl font-bold text-white" data-id="element-93">{edu.degree}</h4>
                  <div className="flex items-center text-purple-400 mb-2" data-id="element-94">
                    <span data-id="element-95">{edu.institution}</span>
                    <span className="mx-2" data-id="element-96">•</span>
                    <span data-id="element-97">{edu.year}</span>
                  </div>
                  <p className="text-gray-300" data-id="element-98">{edu.description}</p>
                </div>)}
            </div>
            <div className="mt-12" data-id="element-99">
              <h3 className="text-2xl font-bold text-white mb-6" data-id="element-100">Skills</h3>
              <div className="grid grid-cols-2 gap-4" data-id="element-101">
                <div data-id="element-102">
                  <h4 className="text-lg font-semibold text-purple-400 mb-3" data-id="element-103">
                    Design Tools
                  </h4>
                  <ul className="text-gray-300 space-y-2" data-id="element-104">
                    <li data-id="element-105">Figma</li>
                    <li data-id="element-106">Adobe XD</li>
                    <li data-id="element-107">Sketch</li>
                    <li data-id="element-108">Adobe Photoshop</li>
                    <li data-id="element-109">Adobe Illustrator</li>
                  </ul>
                </div>
                <div data-id="element-110">
                  <h4 className="text-lg font-semibold text-purple-400 mb-3" data-id="element-111">
                    Design Skills
                  </h4>
                  <ul className="text-gray-300 space-y-2" data-id="element-112">
                    <li data-id="element-113">Wireframing</li>
                    <li data-id="element-114">Prototyping</li>
                    <li data-id="element-115">User Research</li>
                    <li data-id="element-116">Visual Design</li>
                    <li data-id="element-117">Interaction Design</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};